import {
  helpWidgetDragWidgetNewSrc4Evid1508,
  helpWidgetLoadWidgetInBackgroundNewSrc4Evid1501,
  helpWidgetWidgetCloseNewSrc4Evid1503,
} from '@wix/bi-logger-customer-care-data/v2';
import webBiLogger from '@wix/web-bi-logger';
import { WidgetClosingTrigger } from '@wix/wix-chatbot-common/bi';
import { getBiAreaAndPlatform } from '@wix/wix-chatbot-common/browser';

import { getState } from '../store';
import { getContext } from '../utils/context';

const logger = webBiLogger.factory().logger();

// Common BI context interface
interface BiContext {
  context_area: string;
  context_platform: string;
  context_url: string;
  target_account_id?: string;
}

// Helper to get common BI context
const getBiContext = (): BiContext => {
  const url = new URL(window.location.href);
  const { contextArea, contextPlatform } = getBiAreaAndPlatform(url.href);
  const {
    context: { user },
  } = getState();

  return {
    context_area: contextArea,
    context_platform: contextPlatform,
    context_url: `${url.origin}${url.pathname}`, // URL without query params
    target_account_id: user?.accountId,
  };
};

// Event specific logging functions
export const logHelpWidgetLoadInBackground = async () => {
  const biContext = getBiContext();
  const context = await getContext();
  const {
    chatbot: { conversation },
  } = getState();

  const { metaSiteId } = context;

  logger.report(
    helpWidgetLoadWidgetInBackgroundNewSrc4Evid1501({
      context_msid: metaSiteId,
      notification_count: conversation.unreadCount || 0,
      ...biContext,
    }),
  );
};

// New BI event for widget close - evid 1503
export const logHelpWidgetWidgetOpenClose = async (closingTrigger?: WidgetClosingTrigger) => {
  const biContext = getBiContext();
  const context = await getContext();
  const {
    chatbot: { conversation },
    widgetSessionId,
    bi: { placement },
  } = getState();

  const { metaSiteId } = context;

  logger.report(
    helpWidgetWidgetCloseNewSrc4Evid1503({
      chatbot_conversation_id: conversation.conversationId,
      closing_trigger: closingTrigger || undefined,
      context_msid: metaSiteId,
      open_source: placement || undefined,
      open_source_info: undefined,
      self_service_session_id: widgetSessionId,
      widget_language: conversation.lang,
      widget_page_type: undefined,
      ...biContext,
    }),
  );
};

export const logHelpWidgetDragWidget = async () => {
  const biContext = getBiContext();
  const context = await getContext();
  const {
    chatbot: { conversation },
    widgetSessionId,
  } = getState();

  logger.report(
    helpWidgetDragWidgetNewSrc4Evid1508({
      ...biContext,
      context_msid: context.metaSiteId,
      self_service_session_id: widgetSessionId,
      chatbot_conversation_id: conversation.conversationId,
    }),
  );
};
